import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useParams } from 'react-router-dom'
import { TokenBaseSupportQuery } from '../../api'
import { NewShowError, NewShowSuccess } from '../../projectData'
import { useState } from 'react'
import Swal from 'sweetalert2'
import { FullPageLoader } from '../../../component/helper'
// import { PanDetails } from './PanDetails'
/**
 * editUserSchema
 * Yup validation schema for token-based support form fields.
 */
const editUserSchema = Yup.object().shape({
    subject: Yup.string().trim().required('Subject is required'),
    message: Yup.string().trim().required('Message is required'),

})

/**
 * TokenBaseSupportForm
 * Renders a support form for token-based queries, handles validation and submission.
 */
export const TokenBaseSupportForm = ({ data, isUserLoading }) => {
    const [redemError, setRedemError] = useState('');
    const [success, setSuccess] = useState(null);
    const { request } = useParams()
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            'request_token': request,
            'subject': '',
            'message': '',
            'type': 'communication_prefrences',
        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {
                setSubmitting(true);
                const confirmResult = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'You want to add this query',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                    customClass: {
                        confirmButton: 'btn btn-danger',
                        cancelButton: 'btn btn-secondary'
                    }
                });
                if (confirmResult.isConfirmed) {
                    const response = await TokenBaseSupportQuery(values)

                    if (Number(response.code) === 1) {
                        resetForm();
                        setSuccess(response.message)
                    } else {
                        setRedemError(response.message)
                    }
                }
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        }
    })

    /**
     * reload
     * Reloads the current page.
     */
    const reload = () => {
        setSuccess('')
        setRedemError('')
    };


    return (<>
        <div className="mt-5">
            {redemError ? (
                <NewShowError error={redemError} closePopup={reload} />
            ) : success ? (
                <NewShowSuccess title={"Query Submitted Successfully"} success={success} closePopup={reload} />
            ) : (
                <form id="kt_form" className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    onSubmit={formik.handleSubmit} noValidate>
                    {formik.isSubmitting && <FullPageLoader />}
                    <div style={{ border: '1px solid #E6E6E6' }} className="card">
                        <div className="card-header" style={{ minHeight: '39px' }}>
                            <div className="card-title fw-semibold fs-5 py-1"> Raise a Query
                            </div>
                        </div>
                        <div className="card-body pt-2 pb-2 border-top">
                            <div className='row'>
                                <div className="col-lg-12 col-xl-12">
                                    <div className='row'>
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">Subject</label>
                                        <div className="col-lg-8 fv-row fv-plugins-icon-container">

                                            <select   {...formik.getFieldProps('subject')} className="form-select" name="subject" >
                                                <option value="">Select Subject</option>
                                                {data && data?.help_subjects?.map((sub, index) => (
                                                    <option key={index} value={sub}>{sub}</option>
                                                ))}
                                            </select>
                                            {/* 
                                        <input
                                            placeholder="Enter Subject"
                                            {...formik.getFieldProps('subject')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='subject'
                                            className={clsx(
                                                'form-control form-control-lg mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.subject && formik.errors.subject },
                                                { 'is-valid': formik.touched.subject && !formik.errors.subject, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        /> */}
                                            {formik.touched.subject && formik.errors.subject ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.subject}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4 col-lg-12 col-xl-12">
                                    <div className='row'>
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">Message</label>
                                        <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                            <textarea
                                                {...formik.getFieldProps('message')}
                                                onChange={formik.handleChange}
                                                name="message"
                                                className="form-control form-control-lg form-control-solid mb-lg-0 mb-3"
                                                placeholder="Type Message"
                                                style={{ height: "200px", width: "100%" }}>
                                            </textarea>

                                            {formik.touched.message && formik.errors.message ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.message}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='card-footer py-2'>
                            <div className="d-flex justify-content-end">
                                <button style={{ background: '#f1416c' }} className="btn btn-primary"
                                    disabled={formik.isSubmitting || !formik.isValid}
                                >
                                    <span className="indicator-label">{formik?.values?.id ? "Update " : "Submit"}</span>
                                    {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            )}


        </div>

    </>
    )
}











